﻿import PlanStatus from '../enums/planStatus';
import SpecStatus from '../enums/specStatus';

/**
 * It checks if the homeStatus has AvailableNow (A).
 * @param homeStatus - The status of the home.
 */
export const hasAvailableNow = (homeStatus) => {
  const statusArray = homeStatus?.split?.(',');

  return statusArray?.some(
    (key) => PlanStatus.fromKey(key) === PlanStatus.AvailableNow || SpecStatus.fromKey(key) === SpecStatus.AvailableNow
  );
};

/**
 * It checks if the homeStatus has ReadyToBuild (R).
 * @param homeStatus - The status of the home.
 */
export const hasReadyToBuild = (homeStatus) => {
  const statusArray = homeStatus?.split?.(',');

  return statusArray?.some(
    (key) => PlanStatus.fromKey(key) === PlanStatus.ReadyToBuild || SpecStatus.fromKey(key) === SpecStatus.ReadyToBuild
  );
};

/**
 * It checks if the homeStatus has UnderConstruction (UC).
 * @param homeStatus - The status of the home.
 */
export const hasUnderConstruction = (homeStatus) => {
  const statusArray = homeStatus?.split?.(',');

  return statusArray?.some(
    (key) =>
      PlanStatus.fromKey(key) === PlanStatus.UnderConstruction ||
      SpecStatus.fromKey(key) === SpecStatus.UnderConstruction
  );
};

/**
 * It checks if the homeStatus has Model (M).
 * @param homeStatus - The status of the home.
 */
export const hasModelHome = (homeStatus) => {
  const statusArray = homeStatus?.split?.(',');

  return statusArray?.some((key) => SpecStatus.fromKey(key) === SpecStatus.Model);
};

/**
 * It checks if the homeStatus has Hot Deal (H)
 * @param homeStatus - The status of the home.
 */
export const hasHotDeal = (homeStatus) => {
  const statusArray = homeStatus?.split?.(',');

  return statusArray?.some(
    (key) => PlanStatus.fromKey(key) === PlanStatus.HotDeals || SpecStatus.fromKey(key) === SpecStatus.HotDeals
  );
};

/**
 * It checks if the homeStatus has Inventory status combination (A,UC).
 * @param homeStatus - The status of the home.
 */
export const hasInventoryStatusCombination = (homeStatus) => {
  const isAvailableNowIncluded = hasAvailableNow(homeStatus);
  const isUnderConstructionIncluded = hasUnderConstruction(homeStatus);

  return isAvailableNowIncluded && isUnderConstructionIncluded;
};

/**
 * Returns the Inventory status combination (A,UC).
 * @param homeStatus - The status of the home.
 */
export const getInventoryStatusCombination = () => {
  const inventoryStatuses = [SpecStatus.AvailableNow.name, SpecStatus.UnderConstruction.name];

  return inventoryStatuses.join(',');
};